import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-invalid-email-page',
    templateUrl: './invalid-email-page.component.html',
    styleUrls: ['./invalid-email-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvalidEmailPageComponent {

}
